"use client";
import { LIST_BREADCRUMB, LIST_ROUTER_NOT_DYNAMIC } from "@/const/data.const";
import { IBreadcrumbItemModel } from "@/models";
import { createPathPattern } from "@/utils/common.utils";
import { Box } from "@mui/material";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { useMemo } from "react";

const Breadcrumb = () => {
  const path = usePathname();
  const breadcrumb = useMemo<IBreadcrumbItemModel[]>(() => {
    const isDynamic =
      LIST_ROUTER_NOT_DYNAMIC.findIndex((c) => c === path) === -1;
    return LIST_BREADCRUMB.filter((c) => {
      if (isDynamic) {
        const pattern = createPathPattern(c.path);
        return pattern.test(path);
      } else {
        return c.path === path;
      }
    });
  }, [path]);
  return (
    <Box className="hidden min-[992px]:flex items-center justify-start gap-1">
      {breadcrumb && breadcrumb.length > 0 && (
        <>
          {breadcrumb.map((c, index) => {
            if (c.router)
              return (
                <Link
                  className="text-white h3 font-semibold"
                  key={index}
                  href={c.router}
                >
                  {c.name}{" "}
                  {index < breadcrumb.length - 1 ? (
                    <>&nbsp; {">"} &nbsp;</>
                  ) : (
                    ""
                  )}
                </Link>
              );
            else
              return (
                <span className="text-white h3 font-semibold" key={index}>
                  {c.name}{" "}
                  {index < breadcrumb.length - 1 ? (
                    <>&nbsp; {">"} &nbsp;</>
                  ) : (
                    ""
                  )}
                </span>
              );
          })}
        </>
      )}
    </Box>
  );
};

export default Breadcrumb;
